export class Backtotop {

	init() {
		$( '.back-to-top' ).click( function ( e ) {
			e.preventDefault()
			$( 'html, body' ).animate( { scrollTop: 0 }, 600 )
		} )
	}
}


// WEBPACK FOOTER //
// ./scripts/components/back-to-top.js